import { StreamQueryQuery } from '@/__generated__/graphql.ts';

/**
 * use this func when you need to check if user has an active
 * subscription for the stream or if the stream is included in
 * a package that the user has purchased
 *
 * Example of when this is useful:
 * if a user purchases a stream and then unfollows it - the
 * backend returns `stream.accessAllowed: false` and blocks access
 *  to the stream's posts. Using this function, you can still
 * indicate to the user that they have a valid subscription, even
 * though they currently can't see the posts.
 */
export const hasRightsToStream = (
  stream: NonNullable<StreamQueryQuery['stream']>,
) => {
  return (
    stream.accessAllowed ||
    stream.subscription?.active ||
    stream.inPackages.some((pack) => pack.subscription?.active)
  );
};
